import {Store} from "vuex";
import {CommentRepository} from "@api/repositories/CommentRepository";
import {ArrayHelpers} from "@common/ArrayHelpers";

export class CommentsService {
    constructor(
        private readonly store: Store<any>,
        private readonly commentRepository: CommentRepository,
    ) {
    }

    public async fetchCount(ids: string[], schemaId: string): Promise<Record<string, number>> {
        let result = {};
        if (ids.length) {
            try {
                const list = await this.commentRepository.count(schemaId, ids) || [];
                result = ArrayHelpers.keyByWith(list, 'objectId', 'count')
            }
            catch (e) {
                this.store.dispatch('reportException', e, { root: true });
            }
        }
        return result;
    }
}